// JsFromRoutes CacheKey 84870f672f4777800fecb1ed4f34b72d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_series/search'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/gift_series'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_series'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/gift_series/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/gift_series/:id'),
}
